import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { useState } from 'react';

function DateRangeReport({ onRunReport }) {
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());

    return (
        <div className="mt-2">
            <div className="card flex flex-wrap gap-3 p-fluid">
                <div className="flex-auto">
                    <label htmlFor="dateStart" className="font-bold block mb-2">
                        Start Date
                    </label>

                    <Calendar
                        name="dateStart"
                        inputId="dateStart"
                        value={dateStart}
                        onChange={(e) => setDateStart(e.value)}
                    />
                </div>

                <div className="flex-auto">
                    <label htmlFor="dateEnd" className="font-bold block mb-2">
                        End Date
                    </label>

                    <Calendar
                        name="dateEnd"
                        inputId="dateEnd"
                        value={dateEnd}
                        onChange={(e) => setDateEnd(e.value)}
                    />
                </div>
            </div>

            <div className="mt-2">
                <Button
                    label="Run Report"
                    icon="pi pi-check"
                    onClick={() => {
                        onRunReport({ start: dateStart.toISOString(), end: dateEnd.toISOString() });
                    }}
                />
            </div>
        </div>
    );
}

export default DateRangeReport;
